import React, { useRef, useState, useEffect } from 'react';

import {
    Container,
    Slider,
    Heading,
    Text,
    Row,
    Col,
    className,
    ImageComponent,
} from 'aplazame-design-system';

import style from './style.module.scss';
import textStyle from 'aplazame-design-system/src/scss/text.module.scss';

const sliderSettings = {
    controls: false,
    loop: false,
    nav: false,
    mouseDrag: true,
    items: 2,
    gutter: 8,
    edgePadding: 44,
    responsive: {
        768: {
            items: 3,
            edgePadding: 88,
            gutter: 24,
        },
        992: {
            items: 6,
            edgePadding: 0,
        },
    },
};

export default function LogosSection({ logos, title, titleTag, text, id }) {
    const [isFirst, setIsFirst] = useState(true);
    const [isLast, setIsLast] = useState(false);
    const sliderRef = useRef();

    useEffect(() => {
        const configureClasses = (slider) => {
            setIsFirst(slider.index === 0 ? true : false);
            setIsLast(slider.index + 1 === slider.slideCount ? true : false);
        };

        if (sliderRef.current) {
            sliderRef.current.slider?.events?.on(
                'indexChanged',
                configureClasses
            );
        }

        return () => {
            if (sliderRef.current) {
                sliderRef.current.slider?.events?.off(
                    'indexChanged',
                    configureClasses
                );
            }
        };
    }, [setIsFirst, setIsLast, sliderRef]);

    return (
        <section aria-labelledby={id}>
            <Container pt={{ lg: 5 }} pb={{ lg: 5 }}>
                {title || text ? (
                    <Row>
                        <Col
                            className="text-lg-center"
                            col={{ lg: 8 }}
                            offset={{ lg: 2 }}
                            pb={{ lg: 5 }}
                        >
                            {title ? (
                                <Heading
                                    id={id}
                                    tag={titleTag}
                                    className={`h2 ${textStyle.gradual} mb-5 ${style.heading}`}
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                >
                                    {title}
                                </Heading>
                            ) : null}
                            {text ? (
                                <Text
                                    tag="div"
                                    className={`h3 ${style.text}`}
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                >
                                    {text}
                                </Text>
                            ) : null}
                        </Col>
                    </Row>
                ) : null}
                <div data-sal="slide-up" data-sal-easing="ease-out-quart">
                    <div
                        className={`${style.slider} ${isFirst ? style['slider--in-first'] : ''
                            } ${isLast ? style['slider--in-last'] : ''}`}
                    >
                        <Slider
                            parentRef={sliderRef}
                            settings={{
                                ...sliderSettings,
                                responsive: {
                                    ...sliderSettings.responsive,
                                    992: {
                                        ...sliderSettings.responsive[992],
                                        items: logos.length,
                                    },
                                },
                            }}
                        >
                            {logos.map((logo, i) => (
                                <div
                                    key={i}
                                    {...className(
                                        `${style['slider__slide']} pt-10 pb-10`
                                    )}
                                >
                                    <ImageComponent image={logo} />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </Container>
        </section>
    );
}
